(function () {
	let swiperInstance = null;

	function initSwiper() {
		// Ensure required elements exist
		const container = document.querySelector(".slider-demo");
		const wrapper = document.querySelector(".slider-demo-wrapper");
		if (!container || !wrapper) return;

		// Initialize once; works for both desktop and mobile
		if (!swiperInstance) {
			wrapper.classList.add("swiper-wrapper");

			const elements = document.querySelectorAll(
				".slider-demo > .swiper-wrapper > *"
			);

			elements.forEach((element) => {
				element.classList.add("swiper-slide");
			});

			swiperInstance = new Swiper(".slider-demo", {
				direction: "vertical",
				speed: 400,
				effect: "creative",
				creativeEffect: {
					prev: {
						translate: [0, "-20%", -1],
					},
					next: {
						translate: [0, "100%", 0],
					},
				},
				// Mouse wheel on desktop; touch works by default on mobile
				mousewheel: {
					forceToAxis: true,
					releaseOnEdges: false,
					sensitivity: 1,
					thresholdDelta: 20,
					thresholdTime: 200,
				},
				touchReleaseOnEdges: false,
				touchRatio: 0.25,
				longSwipes: true,
				freeMode: false,
				on: {
					slideChangeTransitionStart: changeNavStyle,
				},
			});

			changeNavStyle();
		}
	}

	function changeNavStyle() {
		const stickyNav = document.querySelector(".shopify-section-header");
		if (!stickyNav) return;
		const activeSlideBg = document.querySelector(
			".swiper-slide-active > .background"
		);
		if (!activeSlideBg) return;

		const backgroundColor = window.getComputedStyle(activeSlideBg).backgroundColor;
		const isLightBackground = isLightColor(backgroundColor);

		if (isLightBackground) {
			stickyNav.classList.add("color-background-1");
			stickyNav.classList.remove("color-background-2");
		} else {
			stickyNav.classList.add("color-background-2");
			stickyNav.classList.remove("color-background-1");
		}
	}

	function isLightColor(color) {
		const rgb = (color.match(/\d+/g) || [0, 0, 0]).map(Number);
		const luminance = 0.299 * rgb[0] + 0.587 * rgb[1] + 0.114 * rgb[2];
		return luminance > 186;
	}

	initSwiper();

	window.addEventListener("resize", function () {
		initSwiper();
	});
	document.addEventListener("shopify:section:load", function () {
		// In case Shopify replaces the section DOM, clear and re-init
		if (swiperInstance && typeof swiperInstance.destroy === "function") {
			swiperInstance.destroy(true, true);
			swiperInstance = null;
		}
		initSwiper();
	});
})();
